import React, { useState } from 'react'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Arrow from '../../../assets/icons/JSX/RightArrow'
//
//
const AccordionWithBackground: React.FC<{
  children?: React.ReactNode
  title?: string
  openAccordion?: boolean
  className?: string
  isRtl?: boolean
}> = ({ children, title = 'title', openAccordion = false, className }) => {
  //
  const [open, setOpen] = useState<boolean>(openAccordion)
  //
  return (
    <Wrapper $open={open} className={className}>
      <Head $open={open} onClick={() => setOpen(!open)} className="accordion-head">
        <ArrowStyle $open={open} />
        <Title className="accordion-head-title">{title}</Title>
      </Head>
      <Content style={open ? {} : { display: 'none' }}>{children}</Content>
    </Wrapper>
  )
}
//
// styles
const Title = styled.span`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  user-select: none;
  margin-left: 17px;

  ${Responsive.tablet} {
    margin-left: 10px;
  }

  ${Responsive.mobile} {
    margin-left: 10px;
  }
`
const ArrowStyle = styled(Arrow)<{ $open: boolean }>`
  transform: ${({ $open }) => ($open ? 'rotate(-90deg)' : 'rotate(90deg)')};
  color: ${({ $open }) => ($open ? `${Colors.primaryBlack}` : `${Colors.rollingStone}`)};
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin-top: 2px;
  /*  */
  ${Responsive.tablet} {
    width: 13px;
    height: 13px;
  }
  ${Responsive.mobile} {
    width: 13px;
    height: 13px;
  }
`
const Content = styled.div`
  padding-inline: 90px;
  padding-bottom: 38px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  /*  */
  ${Responsive.tablet} {
    padding-inline: 50px;
    padding-bottom: 35px;
  }
  ${Responsive.mobile} {
    padding-inline: 50px;
    padding-bottom: 35px;
  }
`
const Head = styled.div<{ $open: boolean }>`
  padding-block: ${({ $open }) => ($open ? '33px  20px' : '33px')};
  margin-inline: 56px;
  border-bottom-left-radius: ${({ $open }) => ($open ? 'inherit' : '0px')};
  border-bottom-right-radius: ${({ $open }) => ($open ? 'inherit' : '0px')};
  border-bottom: ${({ $open }) => ($open ? 'none' : `1px solid ${Colors.secondaryGrey}`)};

  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;

  /*  */
  ${Responsive.tablet} {
    margin-inline: 12px;
    padding: ${({ $open }) => ($open ? '22px 12px 16px 12px' : '22px 12px')};
  }
  ${Responsive.mobile} {
    margin-inline: 12px;
    padding: ${({ $open }) => ($open ? '22px 12px 16px 12px' : '22px 12px')};
  }
`
const Wrapper = styled.div<{ $open: boolean }>`
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  width: 100%;
  border-radius: 8px;
  background-color: ${({ $open }) => ($open ? Colors.lightGrey : Colors.white)};
  box-shadow: ${({ $open }) => ($open ? `0px 0px 15px 1.5px ${Colors.white}` : 'unset')};
`
//
export default AccordionWithBackground
